<template>
  <div>
    <!-- <Header></Header> -->
    <div class="tipContent" v-if="isTip">
      您当前使用的浏览器版本过低，可能会出现界面显示异常或功能无法正常使用等问题，建议您更换为更高版本的浏览器
    </div>
    <div class="header" id="header" :class="{ 'header-bg': isScrolled }">
      <div class="head-content" :class="{ 'head-content-bg': isScrolled }">
        <div class="ai-logo">
          <a href="">
            <img
              v-if="headerLogoPath"
              :src="headerLogoPath"
              :alt="curHost + ' logo'"
            />
          </a>
        </div>
        <div class="head-nav">
          <!-- <ul>
						<li class="nav-text"><router-link to="/">首页</router-link></li>
						<li class="nav-text" @mouseenter="enter(1)" @mouseleave="leave(1)">
							<a href="javascript:;">解决方案</a>
							<div class="secone-nav box-shadow" v-show="seenSolution" style="width: 180px;">
								<p><router-link to="/GasSolution">智慧燃气解决方案</router-link></p>

							</div>
						</li>
						<li class="nav-text" @mouseenter="enter(2)" @mouseleave="leave(2)">
							<a href="javascript:;">支持与服务</a>
							<div class="secone-nav box-shadow" v-show="seenService">
								<p><router-link to="/Service">支持与服务</router-link></p>
							</div>
						</li>
						<li class="nav-text" @mouseenter="enter(3)" @mouseleave="leave(3)">
							<a href="javascript:;">关于我们</a>
							<div class="secone-nav box-shadow" v-show="seenAbout">
								<p><router-link to="/About">关于我们</router-link></p>
							</div>
						</li>
					</ul> -->
        </div>
        <div
          class="language-change"
          @mouseenter="languageEnter"
          @mouseleave="languageLeave"
        >
          <a class="lang-title" href="javascript:;">{{ $t("lang") }}</a>
          <div class="language-level" v-show="showLanguage">
            <ul v-for="(lang, index) in $t('languages')" :key="index">
              <li>
                <a
                  class="lang"
                  href="javascript:;"
                  @click="changeLanguage(lang.value)"
                  >{{ lang.name }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <div class="foot" v-if="isFooter">
      <div class="foot-content">
        <div class="ai-logo-foot">
          <img
            v-if="footerLogoPath"
            :src="footerLogoPath"
            :alt="curHost + ' footer logo'"
          />
        </div>
        <div class="foot-nav">
          <div class="foot-nav-left">
            <!-- 倍思 -->
            <ul class="foot-nav-ul" v-if="curHost == 'baseus'">
              <li>
                <div class="work-time worktime">
                  <h5>{{ $t("contact.contact") }}</h5>
                  <p>{{ $t("contact.telphone") }}</p>
                  <p>{{ $t("contact.email") }}</p>
                  <p>{{ $t("contact.timeFrame") }}</p>
                </div>
              </li>
              <li class="contact-way">
                <h5>{{ $t("contact.linkTitle") }}</h5>

                <p>
                  <a href="https://www.baseus.com/" target="_blank">{{
                    $t("contact.baseUs")
                  }}</a>
                </p>
              </li>
            </ul>

            <ul class="foot-nav-ul" v-else>
              <li
                class="contact-way"
                v-if="
                  (curHost == 'www' && brandSubdomain === 'www') || curHost == 'app'
                "
              >
                <h5>{{ $t("contact.link") }}</h5>
                <p>
                  <a href="https://www.aioffice.ltd/" target="_blank">{{
                    $t("contact.oldAddress")
                  }}</a>
                </p>
              </li>
              <li
                class="qrcode"
                v-if="
                  (curHost == 'www' && brandSubdomain === 'www') || curHost == 'app'
                "
              >
                <div class="qrcode-img">
                  <img src="../assets/images/ai-img-douyin-bg.png" alt="" />
                  <p>{{ $t("contact.douyin") }}</p>
                </div>
              </li>
              <li class="company-info" v-if="curHost.includes('zxhy')">
                <ol>
                  <li>深圳市众鑫鸿业科技有限公司</li>
                  <li>地址：深圳市宝安区沙井街道新沙路鑫鑫田工业园10栋5楼</li>
                  <li>电话：0755-84719812</li>
                  <li>传真：0755-29404505</li>
                </ol>
              </li>
              <li class="company-info" v-if="curHost.includes('hgai')">
                <ol>
                  <li>公司:深圳亨谷科技集团有限公司</li>
                  <li>地址:广东省深圳市罗湖区蔡屋围发展大厦2405-2406</li>
                  <li>电话:+86-400-651-16676</li>
                  <li>官网: <a href="https://www.hgwld.com/" target="_blank" rel="noopener noreferrer">https://www.hgwld.com/</a> </li>
                </ol>
              </li>
            </ul>
          </div>
          <div class="foot-nav-right">
            <div class="work-time worktime">
              <h5>{{ $t("contact.worktime") }}</h5>
              <p>{{ $t("contact.timeFrame") }}</p>
            </div>
            <ul class="foot-nav-qrcode">
              <li
                class="qrcode"
                v-for="item in footerQrcodeItems"
                :key="item.key"
              >
                <div class="qrcode-img">
                  <img :src="item.src" alt="" />
                </div>
                <p>{{ $t(item.labelKey) }}</p>
              </li>
              <!-- 二维码组-新 -->
              <template
                v-if="
                  ['xunxiang', 'zxhy','wifi'].some((host) => brandSubdomain.includes(host))
                "
              >
                <li
                  class="qrcode"
                  v-for="(item, index) in codeList"
                  :key="index"
                >
                  <div class="qrcode-img">
                    <img :src="item.src" alt="Image" />
                    <p v-if="item.name">{{ item.name }}</p>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
        <p class="record-no">
          <a href="https://beian.miit.gov.cn/"
            >Copyright@ 粤ICP备2022076506号</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
//import Header from './content/Header.vue'
import store from "@/store/index.js";
import footerQrcodeConfig from "@/config/footerQrcodeConfig";

export default {
  components: {
    //Header,
  },
  data() {
    return {
      scroll: "",
      isScrolled: false,
      seenSolution: false,
      seenService: false,
      seenAbout: false,
      lang: "",
      showLanguage: false,
      isTip: false, //浏览器版本判断
      curHost: "",
      isFooter: true,
      codeList: [],
      brandSubdomain: "",
      // Logo配置映射 - 使用动态路径函数
      logoConfig: {
        header: {
          // 默认（www/app）
          default: () => require("../assets/logo/qingjing/ai-img-logo1.png"),
          shadow: () => require("../assets/logo/zhuoyao/logo.png"),
          imouse: () => "", // 空字符串表示没有logo
          dido: () => require("../assets/logo/dido/logo.png"),
          eweadn: () => require("../assets/logo/eweadn/logo.png"),
          dario: () => require("../assets/logo/dario/logo.png"),
          yundesk: () => require("../assets/logo/yundesk/logo.png"),
          greatwall: () => require("../assets/logo/greatwall/logo.png"),
          xbantu: () => require("../assets/logo/xbantu/logo.png"),
          aioa: () => require("../assets/logo/aioa/logo.png"),
          metav: () => require("../assets/logo/metav/logo.png"),
          wo: () => require("../assets/logo/wo/logo.png"),
          taiguo: () => require("../assets/logo/taiguo/logo.png"),
          jiabo: () => require("../assets/logo/jiabo/logo.png"),
          zhunxin: () => require("../assets/logo/zhunxin/logo.png"),
          jiyuai: () => require("../assets/logo/jiyuai/logo.png"),
          shinco: () => require("../assets/logo/shinco/logo.png"),
          miaowang: () => require("../assets/logo/miaowang/logo.png"),
          mifi: () => require("../assets/logo/miaowang/logo.png"),
          ysd: () => require("../assets/logo/ysd/logo.png"),
          akpnai: () => require("../assets/logo/akpnai/logo.png"),
          hyundai: () => require("../assets/logo/hyundai/logo.png"),
          xunxiang: () => require("../assets/logo/xunxiang/ai-img-logo.png"),
          baseus: () => require("../assets/logo/baseus/logo.png"),
          cmcloud: () => require("../assets/logo/cmcloud/logo.png"),
          dike: () => require("../assets/logo/dike/logo.png"),
          dioc: () => require("../assets/logo/dioc/logo.png"),
        },
        footer: {
          // 默认（www/app）
          default: () => require("../assets/logo/qingjing/ai-img-logo1.png"),
          shadow: () => require("../assets/logo/zhuoyao/logo-w.png"),
          imouse: () => require("../assets/logo/cleverAI/logo-w.png"),
          dido: () => require("../assets/logo/dido/logo-w.png"),
          eweadn: () => require("../assets/logo/eweadn/logo-w.png"),
          dario: () => require("../assets/logo/dario/logo-w.png"),
          yundesk: () => require("../assets/logo/yundesk/logo-w.png"),
          greatwall: () => require("../assets/logo/greatwall/logo-w.png"),
          xbantu: () => require("../assets/logo/xbantu/logo-w.png"),
          aioa: () => require("../assets/logo/aioa/logo-w.png"),
          metav: () => require("../assets/logo/metav/logo-w.png"),
          wo: () => require("../assets/logo/wo/logo-w.png"),
          taiguo: () => require("../assets/logo/taiguo/logo-w.png"),
          jiabo: () => require("../assets/logo/jiabo/logo-w.png"),
          zhunxin: () => require("../assets/logo/zhunxin/logo-w.png"),
          jiyuai: () => require("../assets/logo/jiyuai/logo-w.png"),
          shinco: () => require("../assets/logo/shinco/logo-w.png"),
          miaowang: () => require("../assets/logo/miaowang/logo-w.png"),
          mifi: () => require("../assets/logo/miaowang/logo-w.png"),
          ysd: () => require("../assets/logo/ysd/logo-w.png"),
          akpnai: () => require("../assets/logo/akpnai/logo-w.png"),
          hyundai: () => require("../assets/logo/hyundai/logo-w.png"),
          xunxiang: () => require("../assets/logo/xunxiang/ai-img-logo.png"),
        },
      },
    };
  },
  computed: {
    // 动态获取header logo路径
    headerLogoPath() {
      // 特殊判断：纯www域名（没有其他子域名）或者是app
      if (
        (this.curHost == "www" && this.brandSubdomain === "www") ||
        this.curHost == "app"
      ) {
        return this.logoConfig.header.default();
      }
      // 特殊判断：brandSubdomain包含hbs
      if (this.brandSubdomain.includes("hbs")) {
        return require("../assets/logo/hbs/logo.png");
      }
      if (this.brandSubdomain.includes("cloudeer")) {
        return require("../assets/logo/cloudeer/logo.png");
      }
      if (this.brandSubdomain.includes("newland")) {
        return require("../assets/logo/newland/logo.png");
      }  
      if (this.brandSubdomain.includes("aiodiy")) {
        return require("../assets/logo/aiodiy/logo.png");
      }  
      // 通用映射：优先使用curHost，如果没有则尝试从brandSubdomain中提取
      let hostKey = this.curHost;
      let logoFn = this.logoConfig.header[hostKey];

      if (!logoFn) {
        // 如果curHost没有对应配置，尝试从brandSubdomain中提取（去掉www.前缀）
        hostKey = this.brandSubdomain.replace("www.", "");
        logoFn = this.logoConfig.header[hostKey];
      }

      // 如果找到了配置，执行函数；否则返回null（不显示logo）
      if (logoFn) {
        const result = logoFn();
        return result || null; // 如果返回空字符串，返回null
      }
console.log('logoFn:',logoFn);

      return null; // 没有配置的域名不显示任何logo
    },
    // 动态获取footer logo路径
    footerLogoPath() {
      // 特殊判断：纯www域名（没有其他子域名）或者是app
      if (
        (this.curHost == "www" && this.brandSubdomain === "www") ||
        this.curHost == "app"
      ) {
        return this.logoConfig.footer.default();
      }
      // 通用映射：优先使用curHost，如果没有则尝试从brandSubdomain中提取
      let hostKey = this.curHost;
      let logoFn = this.logoConfig.footer[hostKey];

      if (!logoFn) {
        // 如果curHost没有对应配置，尝试从brandSubdomain中提取（去掉www.前缀）
        hostKey = this.brandSubdomain.replace("www.", "");
        logoFn = this.logoConfig.footer[hostKey];
      }

      // 如果找到了配置，执行函数；否则返回null（不显示logo）
      if (logoFn) {
        const result = logoFn();
        return result || null; // 如果返回空字符串，返回null
      }

      return null; // 没有配置的域名不显示任何logo
    },
    footerQrcodeItems() {
      return footerQrcodeConfig
        .filter((item) => item.visibleHosts.includes(this.brandSubdomain))
        .map((item) => {
          const imageResolver = item.images[this.curHost] || item.images.default;
          if (!imageResolver) {
            return null;
          }
          return {
            key: `${item.key}-${this.curHost}-${this.brandSubdomain}`,
            labelKey: item.labelKey,
            src: imageResolver(),
          };
        })
        .filter(Boolean);
    },
  },
  created() {
    //获取浏览器信息，并判断版本
    let DEFAULT_VERSION = 9.0;
    let ua = navigator.userAgent.toLowerCase();
    let isIE = ua.indexOf("msie") > -1;
    let version = "";
    console.log(isIE + "0000");
    if (isIE) {
      version = ua.match(/msie([\d.]+)/)[1];
      if (version <= DEFAULT_VERSION) {
        this.isTip = true;
      }
    }
    //获取链接
    this.getPageUrl();
  },
  mounted() {
    this.isFooter = window.location.pathname === "/aioffice" ? false : true;

    if (this.curHost == "jiyuai") {
      document.title = "JIYUAI"; // 浏览器标签title
    } else if (this.curHost == "miaowang" || this.curHost == "mifi") {
      document.title = "AI办公助手";
    } else if (this.curHost == "lefan" || this.curHost == "sir") {
      document.title = "AI-Mouse";
    } else if (this.curHost == "yff") {
      document.title = "云非凡";
    } else if (this.curHost == "jingying") {
      document.title = "精英AI";
    } else {
      document.title = "AI-Office"; // 浏览器标签title
    }
    //监听鼠标滚动事件
    window.addEventListener(
      "scroll",
      this.debounce(this.handleScroll, 30),
      true
    ) ||
      window.addEventListener(
        "DOMMouseScroll",
        this.debounce(this.handleScroll, 30),
        false
      );
  },
  methods: {
    //函数防抖
    debounce(func, wait) {
      let timeout;
      return function () {
        let context = this;
        let args = arguments;
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, wait);
      };
    },
    //获取页面链接
    getPageUrl() {
      let url = window.location.href;
     const urlObject = new URL(url);
      // const urlObject = new URL("https://wifi.aioffice.ltd/");

      console.log(urlObject, "urlObject");

      if (urlObject.hostname != "") {
        const hostName = urlObject.hostname.split(".")[0];

        this.curHost = hostName;

        const parts = urlObject.hostname.split(".aioffice"); // 获取 'aioffice' 前面的部分
        this.brandSubdomain = parts[0]; // 输出: 'www.xxx'

        console.log(" 二级域名curHost:", this.curHost);
        console.log("全域名hostname:", urlObject.hostname);
        console.log("aioffice前面的域名（品牌子域名）brandSubdomain:", this.brandSubdomain);
        // 二级域名
        store.commit("setCurrentHost", this.curHost);
        // 全域名
        store.commit("setCurrentFullDomainName", urlObject.hostname);
        // aioffice前面的域名（品牌子域名）
        store.commit("setBrandSubdomain", this.brandSubdomain);

        //获取底部二维码组
        if (["xunxiang", "zxhy","wifi"].some((host) => this.brandSubdomain.includes(host))) {
          this.getFootCodeList(this.brandSubdomain);
        }
      }
    },
    //获取底部二维码组(可扩展二维码下名称)
    getFootCodeList(host) {
      let names = [];
      // 如果是zxhy相关的域名，使用zxhy文件夹
      const folder = host.includes("zxhy") ? "zxhy" : host;
      this.codeList = this.getImagesCode(folder);
      console.log(this.codeList, "底部二维码组");

        if (host.includes("wifi")) {
          names = ["售后客服"];
        }
      if (names) {
        this.codeList.forEach((item, index) => {
          if (names[index]) {
            item.name = names[index];
          }
        });
      }
    },
    // 获取指定文件夹中的所有图片
    getImagesCode(folder) {
      const contextMap = {
        xunxiang: require.context(
          "../assets/code/xunxiang",
          true,
          /\.(png|jpg|jpeg|svg)$/
        ),
        zxhy: require.context(
          "../assets/code/zxhy",
          true,
          /\.(png|jpg|jpeg|svg)$/
        ),
        wifi: require.context(
          "../assets/code/wifi",
          true,
          /\.(png|jpg|jpeg|svg)$/
        ),
      };
      const context = contextMap[folder];
      if (!context) {
        return [];
      }
      // 获取所有code图片的路径
      const images = context
        .keys()
        .map((key) => ({ src: context(key), name: "" })); // 直接使用 context(key) 获取图片路径
      return images;
    },
    //判断滚动方向
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scroll > 0) {
        //document.querySelector('#header').style.backgroundImage = 'rgba(0,0,0,0.2)';
        this.isScrolled = true;
      } else {
        //document.querySelector('#header').style.backgroundColor = 'transparent';
        this.isScrolled = false;
      }
    },
    enter(index) {
      if (index == 1) this.seenSolution = true;
      else if (index == 2) this.seenService = true;
      else if (index == 3) this.seenAbout = true;
    },
    leave(index) {
      if (index == 1) this.seenSolution = false;
      else if (index == 2) this.seenService = false;
      else if (index == 3) this.seenAbout = false;
    },
    //语言界面
    languageEnter() {
      this.showLanguage = true;
    },
    languageLeave() {
      this.showLanguage = false;
    },
    changeLanguage(lang) {
      //console.log(lang)
      if (this.$i18n.locale != lang) {
        this.$root.$i18n.locale = lang;
        store.commit("setCurrentLanguage", lang);
      }
    },
  },
};
</script>

<style lang="scss"></style>
